import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const SiteContentCtx = createContext(null);

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    http.get("/site-content").then((r) => setContent(r.data)).catch(() => setContent({}));
  }, []);

  return <SiteContentCtx.Provider value={content}>{children}</SiteContentCtx.Provider>;
}

export const useSiteContent = () => useContext(SiteContentCtx);
